(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-main-product"] && !Shopify.designMode) return;
  try {
    
  class BdProduct extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-bd-variants]');
      this.variants = raw ? JSON.parse(raw.textContent) : [];
      this.idInput = this.querySelector('[data-bd-variant-id]');
      this.priceEl = this.querySelector('[data-bd-price]');
      this.compareEl = this.querySelector('[data-bd-compare]');
      this.atc = this.querySelector('[data-bd-atc]');
      this.atcLabel = this.querySelector('[data-bd-atc-label]');
      this.atcPrice = this.querySelector('[data-bd-atc-price]');
      this.atcDot = this.querySelector('[data-bd-atc-dot]');
      this.slides = this.querySelector('[data-bd-slides]');
      // La caja de cierre muestra una sola foto en vez de la galería entera.
      this.solo = this.querySelector('.bd-bx__photo');

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-bd-value]')) this.onSelect();
      });

      this.bindThumbs();
      this.refreshAvailability();
    }

    get fieldsets() {
      return Array.from(this.querySelectorAll('[data-bd-option]'));
    }

    selection() {
      return this.fieldsets.map((set) => {
        const checked = set.querySelector('[data-bd-value]:checked');
        return checked ? checked.value : null;
      });
    }

    match(values) {
      return this.variants.find((variant) =>
        values.every((value, index) => variant.options[index] === value)
      );
    }

    onSelect() {
      const values = this.selection();
      const variant = this.match(values);

      this.fieldsets.forEach((set, index) => {
        const output = set.querySelector('[data-bd-option-selected]');
        if (output) output.textContent = values[index] || '';
      });

      this.refreshAvailability();

      if (!variant) {
        this.setUnavailable();
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.compareEl) {
        this.compareEl.textContent = variant.compare_at || '';
        this.compareEl.hidden = !variant.compare_at;
      }

      if (this.atc) this.atc.disabled = !variant.available;
      if (this.atcLabel) {
        this.atcLabel.textContent = variant.available
          ? this.dataset.labelAdd || this.atcLabel.textContent
          : this.dataset.labelSoldOut || this.atcLabel.textContent;
      }
      if (this.atcPrice) {
        this.atcPrice.textContent = variant.price;
        this.atcPrice.hidden = !variant.available;
      }
      if (this.atcDot) this.atcDot.hidden = !variant.available;

      this.showMedia(variant.media_id);

      if (this.solo && variant.image) {
        this.solo.removeAttribute('srcset');
        this.solo.src = variant.image;
      }

      this.syncUrl(variant.id);
    }

    setUnavailable() {
      if (this.atc) this.atc.disabled = true;
      if (this.atcPrice) this.atcPrice.hidden = true;
      if (this.atcDot) this.atcDot.hidden = true;
      if (this.atcLabel && this.dataset.labelSoldOut) {
        this.atcLabel.textContent = this.dataset.labelSoldOut;
      }
    }

    // Marca cada valor que no lleva a ninguna variante disponible, dejando
    // fijos los valores ya elegidos en las demás opciones.
    refreshAvailability() {
      const values = this.selection();

      this.fieldsets.forEach((set, index) => {
        set.querySelectorAll('[data-bd-value]').forEach((input) => {
          const probe = values.slice();
          probe[index] = input.value;

          const reachable = this.variants.some(
            (variant) =>
              variant.available &&
              probe.every((value, i) => value === null || variant.options[i] === value)
          );

          const label = set.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !reachable);
        });
      });
    }

    showMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      const slide = this.slides.querySelector('[data-bd-media-id="' + mediaId + '"]');
      if (!slide) return;
      this.slides.scrollTo({ left: slide.offsetLeft - this.slides.offsetLeft, behavior: 'smooth' });
      this.markThumb(String(mediaId));
    }

    bindThumbs() {
      const thumbs = this.querySelectorAll('[data-bd-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          this.showMedia(thumb.dataset.bdThumb);
        });
      });

      if (!this.slides) return;
      this.slides.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const slides = Array.from(this.slides.children);
          const left = this.slides.scrollLeft;
          const current = slides.find((slide) => Math.abs(slide.offsetLeft - this.slides.offsetLeft - left) < 40);
          if (current) this.markThumb(current.dataset.bdMediaId);
        }, 90);
      });
    }

    markThumb(mediaId) {
      this.querySelectorAll('[data-bd-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.bdThumb === String(mediaId));
      });
    }

    // Mantiene ?variant= en la barra de direcciones para que el enlace se
    // pueda compartir y el back del navegador conserve la selección.
    syncUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (!customElements.get('bd-product')) {
    customElements.define('bd-product', BdProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
